module.exports = __webpack_public_path__ + "img/IT0000104055204.df81e7b8.png";